/**
 * Created by Thomas Mark
 * Date: 2020-05-01
 * Description: Kopfbereich im Hauptdialog
 *
 */


import React from 'react';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import forsales_logo from '../../assets/images/Logo_forsale-s_white.svg'
import * as appActions from "../../store/actions/appActions";
import * as utils from "../../basics/utils";

class Logo extends React.Component {
    constructor(props) {
        super(props);

        this.debug = false;
    }

    render() {

        const renderVersion = () => {

            if (!this.props.version) return null;

            const style = Object.assign(utils.getStyleHeight(this.props.width, .015, .015, .015), { backgroundColor: (this.debug) ? 'blue' : '' });

            return (
                <div className={"absolute top-1 flex font-normal"} style={style}>
                    {process.env.REACT_APP_VERSION}
                </div>
            )
        }

        const renderLogo = (h) => {

            const styleLogo = {
                marginRight: (-20) + 'px',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'right top',
                backgroundImage: "url(" + forsales_logo + ")",
                backgroundColor: (this.debug) ? 'green' : ''
            };

            const style = Object.assign(utils.getStyleHeight(this.props.width, .2, .4, .2), styleLogo);

            return (
                <div className={" text-black"} style={style}></div>
            )
        }

        // ==========================================================================
        // 
        // MAIN RENDER
        // 
        // ==========================================================================

        return (
            <div className="relative w-full h-full flex flex-col text-white " >
                {renderVersion()}
                {renderLogo()}
            </div>
        )
    }
}

function mapStateToProps(state) {
    return {
        app: state.app
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(Object.assign({}, appActions), dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Logo);
